import Vue from 'vue'

const PREPARATION_SET_TEXT =(state, payload)=> {
            
    state.data.text = payload
};




const PREPARATION_SET_DUPLICATE =(state, payload)=> {
            
    state.data.duplicate = payload
};


const PREPARATION_SET_PREPARATIONS =(state, payload)=> {  
    
    state.preparations=payload
    
};

const PREPARATION_SET_PREPARATION =(state, payload)=> {       
    
    state.data.text = payload.text
    
    
};

const PREPARATION_INIT_PREPARATION =(state, payload)=> {       
    state.data.text = ''    
    
};



export default {
    PREPARATION_SET_TEXT,   
    PREPARATION_SET_DUPLICATE,
    PREPARATION_SET_PREPARATIONS,
    PREPARATION_SET_PREPARATION,
    PREPARATION_INIT_PREPARATION,
};